import { ClockCircleOutlined } from "@ant-design/icons";
import { Button, Card, Divider, Tooltip, Typography, Spin } from "antd";
import Meta from "antd/es/card/Meta";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect } from "react";
import { formatDateTime } from "../../Utils/generic-functions";
import Participants from "./Participants";
import { InterviewSchedule } from "../../Entities/interview-schedule.entity";
import { JobApplication } from "../../Entities/job-application.entity";
import InterviewService from "../../Services/interview.service";
import LoaderContext from "../../Context/LoaderContext/Index";
import JobApplicationService from "../../Services/job.application.service";
import { useLoaderData } from "react-router-dom";

interface SlotDetailsProps {
  appliedJob: JobApplication;
}

const SlotDetails: React.FC<SlotDetailsProps> = ({ appliedJob }) => {
  const interviewService = new InterviewService();
  const { isLoading, setLoading } = useContext(LoaderContext);
  const [bookedSlot, setBookedSlot] = React.useState<InterviewSchedule | null>(
    null
  );

  const fetchSlotDetails = async (jobApplicationId: string) => {
    setLoading(true);
    try {
      const jobApplication =
        await new JobApplicationService().findJobApplicationById(
          appliedJob._id
        );
      if (jobApplication?.interviewSchedule) {
        console.log("🚀 ~ fetchSlotDetails ~ jobApplication:", jobApplication);
        const slotDetails = await interviewService.getOnlineInterviewDetails(
          jobApplicationId
        );
        console.log("Fetched slot details:", slotDetails);
        const selectedSlot = slotDetails.find(
          (slot) => slot.startTime === appliedJob.interviewSchedule
        );
        console.log("🚀 ~ fetchSlotDetails ~ selectedSlot:", selectedSlot);
        if (slotDetails && slotDetails.length > 0 && selectedSlot) {
          const localStart = new Date(selectedSlot.startTime).toLocaleString(
            "en-US"
          );
          const localEnd = new Date(selectedSlot.endTime).toLocaleString(
            "en-US"
          );
          selectedSlot.startTime = localStart;
          selectedSlot.endTime = localEnd;

          setBookedSlot(selectedSlot);
        }
      }
    } catch (error) {
      console.error("Error fetching slot details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appliedJob) {
      fetchSlotDetails(appliedJob._id);
    }
  }, []);

  return (
    <Content
      className="preliminaryMatch-content-container"
    >
      <Spin spinning={isLoading}>
        {bookedSlot && (
          <Card bordered={false} style={{ boxShadow: "none", padding: 0 }}>
            <Meta
              title="Time Duration (1 hour)"
              description={
                <Typography.Paragraph style={{ margin: 0 }}>
                  <ClockCircleOutlined /> {formatDateTime(bookedSlot.startTime)}{" "}
                  - {formatDateTime(bookedSlot.endTime)}
                </Typography.Paragraph>
              }
            />

            <Meta
              title="Meeting Link"
              description={
                <Typography.Link
                  href={`https://meet.google.com/${bookedSlot.conferenceId}`}
                  target="_blank"
                  rel="noreferrer"
                  type={
                    new Date(bookedSlot.endTime) < new Date()
                      ? "danger"
                      : undefined
                  }
                  disabled={new Date(bookedSlot.endTime) < new Date()}
                >
                  {new Date(bookedSlot.endTime) < new Date() ? (
                    <Tooltip placement="topRight" title="Link is expired!">
                      <span>{`https://meet.google.com/${bookedSlot.conferenceId}`}</span>
                    </Tooltip>
                  ) : (
                    <span>{`https://meet.google.com/${bookedSlot.conferenceId}`}</span>
                  )}
                </Typography.Link>
              }
              style={{ margin: "16px 0" }}
            />
            <Meta
              title="Participants"
              description={<Participants schedule={bookedSlot} />}
            />
            <Divider />
            <Button
              type="primary"
              onClick={() =>
                window.open(
                  `https://meet.google.com/${bookedSlot.conferenceId}`,
                  "_blank"
                )
              }
              style={{ marginTop: 16 }}
              disabled={new Date(bookedSlot.endTime) < new Date()}
            >
              Join Interview
            </Button>
          </Card>
        )}
      </Spin>
    </Content>
  );
};

export default SlotDetails;
